class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    const sectionId = this.dataset.stickyAtc;
    const target = document.querySelector(`#ProductForm-${sectionId} .buy-buttons__submit`) || document.querySelector(`#ProductForm-${sectionId}`);
    if (!target || !('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-hidden', !passed);
      },
      { threshold: 0 }
    );
    this.observer.observe(target);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
  }
}
if (!customElements.get('sticky-add-to-cart')) customElements.define('sticky-add-to-cart', StickyAddToCart);
